import {register} from '../../../JavaScript/Utils'

export const TeaserCardForm = (el: HTMLElement) => {

  const showFormButton: HTMLElement = el.querySelector('button.show-form-button')

  const prepareButtons = () => {
    if (showFormButton) {
      showFormButton.addEventListener('click', showForm)
    }
  }
  const showForm = (event: Event) => {
    el.classList.remove('hide-form')
    el.classList.add('show-form')
  }

  prepareButtons()

}

register('TeaserCardForm', TeaserCardForm)
